import { render, staticRenderFns } from "./AutoNegativo.vue?vue&type=template&id=4b916248"
import script from "./AutoNegativo.vue?vue&type=script&lang=js"
export * from "./AutoNegativo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports